import {
  ERROR_REQUIRED,
  errorMaxCharsRecommended,
} from '../../../../../../shared/constants/validationErrors';
import { SUBJECT_MAX_LEN } from './buildBasicInformationErrors';
import { addRow, canAddRow, removeRowAt, setRowAt } from './listRowHelpers';

const makeEmptySubject = () => '';

// Per-subject errors, mirroring the Send conditions model: each empty subject lights up
// with a required error (once a save has been attempted on an email template), and each
// over-length subject shows a non-blocking max-length warning. An empty field can't also
// be over-length, so at most one applies per row.
export function buildSubjectErrors({ subjects, isEmail, saveAttempt }) {
  const rows = Array.isArray(subjects) ? subjects : [];
  const required = isEmail && saveAttempt > 0;
  return rows.map((subject) => {
    const value = String(subject ?? '');
    return {
      requiredError: required && value.trim().length === 0 ? ERROR_REQUIRED : '',
      maxLenError:
        isEmail && value.length > SUBJECT_MAX_LEN ? errorMaxCharsRecommended(SUBJECT_MAX_LEN) : '',
    };
  });
}

export function canAddSubject({ subjects, isEmail }) {
  if (!isEmail) return false;
  return canAddRow(subjects, (subject) => String(subject ?? '').trim().length > 0);
}

export function setSubjectAt({ subjects, index, nextValue }) {
  return setRowAt(subjects, index, () => nextValue);
}

export function removeSubjectAt({ subjects, index }) {
  return removeRowAt(subjects, index, makeEmptySubject);
}

export function addSubject({ subjects }) {
  return addRow(subjects, makeEmptySubject);
}
